import _scr_dash from "./images/screenshot.png";
import _logo_navbar from "./images/logo_navbar.png";
import _logo_footer from "./images/logo_footer.png";

export const SCR_DASHBOARD = _scr_dash;
export const LOGO_NAVBAR = _logo_navbar;
export const LOGO_FOOTER = _logo_footer;
